
import { defineComponent } from 'vue';
import MainLayout from '@/layout/MainLayout.vue';
import { useAuthStore } from '@/store/AuthStore';
import { useArtistsStore } from '@/store/ArtistsStore';
import { useShowsStore } from '@/store/ShowsStore';
// import { useArtworksStore } from "@/store/ArtworksStore";
import { useGalleryStore } from '@/store/GalleriesStore';
import { usePrivateSellersStore } from '@/store/PrivateSellersStore';
import {
  ArtistItem,
  ArtworksRecord,
  GalleryShowsItem,
} from '@/dataTypes/types';
import ArtistCard from '@/components/artists/ArtistCard.vue';
import ArtworkCard from '@/components/artworks/ArtworkCard.vue';
import ShowCard from '@/components/shows/ShowCard.vue';

export default defineComponent({
  components: { MainLayout, ArtworkCard, ArtistCard, ShowCard },
  data() {
    const authStore = useAuthStore();
    const artistsStore = useArtistsStore();
    // const artworksStore = useArtworksStore();
    const galleryStore = useGalleryStore();
    const privateSeller = usePrivateSellersStore();
    const showsStore = useShowsStore();
    return {
      authStore,
      artistsStore,
      galleryStore,
      privateSeller,
      showsStore,
      artists: [] as ArtistItem[],
      shows: [] as GalleryShowsItem[],
      artworks: [] as ArtworksRecord[],
      search: '',
    };
  },
  async created() {
    if (this.authStore.isLoggedIn) {
      if (this.authStore.userRole === 'private_seller') {
        await this.privateSeller.fetchMyArtists();
        this.artists = this.privateSeller.myArtists;
        this.artworks = await this.privateSeller.getMyArtworks();
        this.shows = [];
      } else {
        this.artists = await this.artistsStore.fetchMyArtistsLength();
        this.artworks = await this.galleryStore.getMyArtworks();
        const { items: galleryShows } =
          await this.showsStore.fetchGalleryShows();
        this.shows = galleryShows;
      }
    }
  },
  methods: {
    filter(search: string) {
      this.search = search;
    },
  },
  computed: {
    filteredArtists(): ArtistItem[] {
      if (!this.search) {
        return this.artists;
      }
      const query = this.search.toLowerCase();
      return this.artists.filter((artist) =>
        artist.full_name.toLowerCase().includes(query)
      );
    },
    filteredArtworks(): ArtworksRecord[] {
      if (!this.search) {
        return this.artworks;
      }
      const query = this.search.toLowerCase();
      return this.artworks.filter(
        (artwork) =>
          artwork.title.toLowerCase().includes(query) ||
          artwork.artist.full_name.toLowerCase().includes(query)
      );
    },
    filteredShows(): GalleryShowsItem[] {
      if (!this.search) {
        return this.shows;
      }
      const query = this.search.toLowerCase();
      return this.shows.filter((show) =>
        show.title.toLowerCase().includes(query)
      );
    },
  },
});
